import { Component, Input } from '@angular/core';
import { EnvironmentVariablesService } from '@kenv';
import { productDisplayName } from '@kservice';

@Component({
  selector: 'kp-version-tag',
  templateUrl: './version-tag.component.html',
  styleUrls: ['./version-tag.component.scss'],
})
export class VersionTagComponent {
  constructor(private _environmentVariablesService: EnvironmentVariablesService) {
    this.appVersion = this._environmentVariablesService.versions.app[this._environmentVariablesService.product];
    this.npmVersion = this._environmentVariablesService.versions.npm_version;
    this.revision = this._environmentVariablesService.versions.revision;
    this.version = this._environmentVariablesService.latestVersion;
  }

  @Input() hidden = false;

  appVersion: string;
  npmVersion: string;
  product = productDisplayName;
  revision: string;
  version: string;
}
